import styled from 'styled-components'
import { ImageMosaicProps } from './ImageMosaic'

export const MosaiContainer = styled.div<Pick<ImageMosaicProps, 'size' | 'customHeight'>>`
  display: flex;
  height: ${({ customHeight }) => customHeight ?? '250px'};
  width: 100%;
  border-radius: 10px;
  overflow: hidden;
  box-sizing: border-box;

  @media (min-width: 769px) {
    display: grid;
    grid-template-areas:
      'col1 col2'
      'col1 col2';
    height: ${({ size, customHeight }) => customHeight ?? (size === 'sm' ? '395px' : '400px')};
    gap: ${({ size }) => (size === 'sm' ? '10px' : '5px')};
    grid-template-columns: ${({ size }) => (size === 'sm' ? '37% 27% 36%' : '56% 18% 26%')};
    grid-template-rows: ${({ size }) => (size === 'sm' ? '49.5% 50.5%' : '51% 48.7%')};
  }
`

export const MosaicDiv = styled.div<{ index: number; size: 'sm' | 'lg' }>`
  ${({ index }) => (index === 0 ? 'width: 100%; height: 100%' : 'display: none')};

  @media (min-width: 769px) {
    display: block;
    grid-area: ${({ index, size }) =>
      size === 'sm'
        ? index === 0
          ? '1 / 1 / 2 / 2'
          : index === 1
          ? '1 / 2 / 2 / 4'
          : index === 2
          ? '2 / 1 / 3 / 2'
          : index === 3
          ? '2 / 2 / 3 / 3'
          : '2 / 3 / 3 / 4'
        : index === 0
        ? '1 / 1 / 3 / 2'
        : index === 1
        ? '1 / 2 / 2 / 4'
        : index === 2
        ? '2 / 2 / 3 / 3'
        : '2 / 3 / 3 / 4'};
  }
`

export const Image = styled.img<{ isFallback?: boolean }>`
  width: 100%;
  height: 100%;
  object-fit: ${({ isFallback }) => (isFallback ? '' : 'cover')};
  object-position: center;
  cursor: pointer;
`
